import { City } from '@/shared/types/generated';

export const getCityLabel = (city: City) => {
  switch (city) {
    case City.Boston:
      return 'Boston';
    case City.Chicago:
      return 'Chicago';
    case City.Dallas:
      return 'Dallas';
    case City.LongIsland:
      return 'Long Island';
    case City.LosAngeles:
      return 'Los Angeles';
    case City.Miami:
      return 'Miami';
    case City.NewYork:
      return 'New York';
    case City.PalmBeach:
      return 'Palm Beach';
    case City.SanFrancisco:
      return 'San Francisco';
    case City.Seattle:
      return 'Seattle';
    default:
      return '';
  }
};
